<template>
    <div class="vc-checkout-items-list">
        <div class="vc-checkout-items-list__description">
            Please find below your order details and choose your payment method to proceed.
        </div>
        <cart-items-list class="vc-checkout-items-list__content" theme="checkout"></cart-items-list>
    </div>
</template>

<script>
    import CartItemsList from './../cart/cart-items-list.vue'

    export default {
        name: "checkout-items-list",
        components: {
            CartItemsList
        },
    }
</script>

<style lang="scss" scoped>
    .vc-checkout-items-list {
        &__description {
            color: var(--primary-text-color);
            font-size: 12px;
            font-weight: 600;
            margin-bottom: 1rem;
            user-select: none;
        }

        &__content {
            border-bottom: 1px solid var(--primary-text-color-faded-more);
            padding-bottom: 1rem;
        }
    }
</style>